/** 是否存在 van-overlay */
/** 全局只会有一个van-overlay，所以用这个方法判断 */
export default (): boolean => {
  const overlay = document.querySelector('.van-overlay');

  if (overlay) {
    const style = window.getComputedStyle(overlay);
    if (style.display !== 'none' && style.visibility !== 'hidden') {
      return true;
    }
    return false;
  }
  return false;
};
